import { Modal, Snackbar, Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { useEffect, useState } from "react";
import closeIcon from "src/assets/images/icon_close.svg";
import copyIcon from "src/assets/images/icon_copy.png";
import { ProviderItems, StakingPoolItemModel } from "src/models/StakingPool";
import { formatNumber } from "src/utils/numberUtils";
import { DelegateSteps } from "./DelegateSteps";

type DetailsTokenModalProps = {
  item: ProviderItems,
  visible: boolean;
  handleClose: any;
};

export const DetailsTokenModal = (props: DetailsTokenModalProps) => {
  const { item } = props;
  const [copySuccessToastVisible, setCopySuccessToastVisible] = useState(false);



  useEffect(() => {
    setCopySuccessToastVisible(false);
  }, [props.visible]);

  if (!item) {
    return null;
  }

  return (
    <Modal
      open={props.visible}
      onClose={() => {
        props.handleClose && props.handleClose();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        pt="22px"
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        sx={{
          backgroundColor: "#23292F",
          width: "800px",
          paddingBottom: "50px",
          borderRadius: "20px",
          margin: "auto",
          marginTop: "120px",
        }}
      >
        <Stack
          direction="row"
          alignSelf="stretch"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="bold" fontSize="22px" color="white" ml="50px">
            {item.modalTitle}
          </Typography>

          <Box
            width="23px"
            height="23px"
            mr="20px"
            sx={{
              cursor: "pointer",
            }}
            onClick={() => {
              props.handleClose();
            }}
          >
            <img src={closeIcon} width="100%" alt="close" />
          </Box>
        </Stack>

        <Stack
          width="640px"
          height="50px"
          mt="30px"
          alignSelf="center"
          direction="row"
          alignItems="center"
          sx={{
            backgroundColor: "#304D5B",
            borderRadius: "10px",
          }}
        >
          {/* <Typography fontSize="16px" color="#b6b6b6" ml="10px" width="136px">
            Delegate Address
          </Typography> */}

          <Typography
            variant="bold"
            fontSize="18px"
            lineHeight="18px"
            textAlign="start"
            paddingLeft="15px"
            color="white"
            flex={1}
            mr="9px"
          >
            {item.url || "none"}
          </Typography>

          {item.url && (
            <Box
              width="20px"
              height="20px"
              mr="10px"
              sx={{
                cursor: "pointer",
              }}
              onClick={() => {
                navigator.clipboard.writeText(item.url || "").then(
                  function () {
                    setCopySuccessToastVisible(true);
                  },
                  function (err) { }
                );
              }}
            >
              <img src={copyIcon} width="100%" alt="close" />
            </Box>
          )}
        </Stack>

        <Box m="31px 50px 0">
          <Typography 
            fontSize="18px"
            lineHeight="18px"
            color="#E4E9EB"
          >
            {item.describe}
          </Typography>
        </Box>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={copySuccessToastVisible}
          onClose={() => {
            setCopySuccessToastVisible(false);
          }}
          message="Address copied"
          autoHideDuration={2000}
        />
      </Box>
    </Modal>
  );
};
